<template>
  <div>
    <transition name="covering">
      <div class="covering" v-show="isShow">
        <div class="count-Down" v-show="count_Down">
          <span class="days_s">DAYS</span>
          <span class="hrss">HRS</span>
          <span class="mins">MINS</span>
          <span class="secs">SECS</span>
          <div class="dd dd_top dd_left"></div>
          <div class="dd dd_button dd_left"></div>
          <div class="dd dd_top dd_center"></div>
          <div class="dd dd_button dd_center"></div>
          <div class="dd dd_top dd_right"></div>
          <div class="dd dd_button dd_right"></div>

          <!-- <img src="../../assets/images/clue/clock.png" alt /> -->
          <Flipper class="figure day" ref="flipperDay1" />
          <Flipper class="figure days" ref="flipperDay2" />

          <Flipper class="figure hr" ref="flipperHour1" />
          <Flipper class="figure hrs" ref="flipperHour2" />

          <Flipper class="figure minute" ref="flipperMinute1" />
          <Flipper class="figure minutes" ref="flipperMinute2" />

          <Flipper class="figure second" ref="flipperSecond1" />
          <Flipper class="figure seconds" ref="flipperSecond2" />
          </div>
    </div>
    </transition>  
    <!-- <video muted preload class="video-bg" id="home-top-bg" autoplay loop :src="topBgUrl" @canplaythrough="loaded"></video> -->
  </div>
</template>

<script>
import Flipper from "../../components/Flipper";

export default {
  name: "countDown",
  components: { Flipper },
  data: () => ({
    topBgUrl:require("../../assets/mov/home_top_bg.mp4"),
    hvoerIndex: -1,
    timer: "",
    isShow: true,
    inputs: true,
    count_Down: true,
    curStartTime: "2020/01/17 00:00:00+08",
    day: "0",
    hour: "0",
    hours: "0",
    password: "2531", //密码
    passwords: "",
    isOpenPage: 0
  }),
  created() {
    console.log(this.$route.query.id);
    this.isOpenPage = this.$route.query.id;
    this.openPage();
  },
  async mounted() {
    clearInterval(this.timer);
    let res = await this.loadDate();
    this.nowTime = res.data.data.t;
    this.flipObjs = [
      this.$refs.flipperDay1,
      this.$refs.flipperDay2,
      this.$refs.flipperHour1,
      this.$refs.flipperHour2,
      this.$refs.flipperMinute1,
      this.$refs.flipperMinute2,
      this.$refs.flipperSecond1,
      this.$refs.flipperSecond2
    ];
    // this.init();
    // this.run();
    this.iftimer();
  },
  watch: {},
  computed: {
    CLUE_STAGE() {
      return this.$store.state.CLUE_STAGE;
    }
  },
  methods: {
    openPage() {
      if (this.isOpenPage == 123) {
        return;
      } else {
        this.$router.push("home");
      }
    },
    loadDate() {
      return this.axios.get("/time");
      // .then(function(res){
      //   console.log(res)
      //   this.nowTime = res.data.data.t;
      //   console.log(this.nowTime);
      // })
      // .catch(function(res){
      //   console.log(res)
      // })
    },
    iftimer() {
      var startTime = new Date(this.curStartTime).getTime();
      var endTime = new Date().getTime();
      console.log(startTime, endTime);
      //进行比较
      if (startTime <= endTime) {
        //   for (let i = 0; i < this.flipObjs.length; i++) {
        //   this.flipObjs[i].setFront(nowTimeStr[i]);
        // }
        console.log("超时");
        //this.video_s = true;
     
              this.video_s = false;
              this.count_Down = false;
              this.download = true;
         
        return;
      } else {
        this.init();
        this.run();
      }
    },
    // 初始化数字
    init() {
      // 获取当前时间
      // let date = new Date();
      let now = this.nowTime;
      // 设置截止时间
      let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
      let end = endDate.getTime();

      // 时间差
      let leftTime = end - now + (new Date().getTimezoneOffset()*60*1000);
      let nowTimeStr = this.formatDate(new Date(leftTime), "ddhhiiss");
      console.log(nowTimeStr);
      for (let i = 0; i < this.flipObjs.length; i++) {
        this.flipObjs[i].setFront(nowTimeStr[i]);
      }
    },
    // 开始计时
    run() {
      let now = this.nowTime;
      let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
      let end = endDate.getTime();
      let leftTime = end - now + (new Date().getTimezoneOffset()*60*1000);
      let _this = this;
      // console.log(leftTime,22222)
      this.timer = setInterval(() => {
        leftTime -= 1000;
        // 获取当前时间
        // 获取当前时间
        // let date = new Date();
        // console.log(date)
        let nowTimeStr = _this.formatDate(
          new Date(leftTime + 1000),
          "ddhhiiss"
        );
        let nextTimeStr = _this.formatDate(new Date(leftTime), "ddhhiiss");
        // 设置截止时间
        // 时间差
        for (let i = 0; i < _this.flipObjs.length; i++) {
          if (nowTimeStr[i] === nextTimeStr[i]) {
            continue;
          }
          if (nowTimeStr == "00000001") {
            console.log("时间0");
            clearInterval(_this.timer);
          }
          if (nextTimeStr === "00000000") {
            _this.video_s = true;
            console.log("111");
            setTimeout(function() {
              _this.video_s = false;
              _this.count_Down = false;
              _this.download = true;
              console.log("333");
            }, 9000);
          }
          _this.flipObjs[i].flipDown(nowTimeStr[i], nextTimeStr[i]);
        }
      }, 1000);
    },
    // 正则格式化日期
    formatDate(date, dateFormat) {
      /* 单独格式化年份，根据y的字符数量输出年份
     * 例如：yyyy => 2019
            yy => 19
            y => 9
     */
      if (/(y+)/.test(dateFormat)) {
        dateFormat = dateFormat.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      // console.log(date)
      // 格式化月、日、时、分、秒
      let o = {
        "m+": date.getMonth() + 1,
        // "d+": date.getDate()  ,
        "d+": this.DateMinus(new Date(), this.curStartTime),
        "h+": date.getHours(),
        "i+": date.getMinutes(),
        "s+": date.getSeconds()
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(dateFormat)) {
          // 取出对应的值
          let str = o[k] + "";
          /* 根据设置的格式，输出对应的字符
           * 例如: 早上8时，hh => 08，h => 8
           * 但是，当数字>=10时，无论格式为一位还是多位，不做截取，这是与年份格式化不一致的地方
           * 例如: 下午15时，hh => 15, h => 15
           */
          dateFormat = dateFormat.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      // console.log(dateFormat);
      return dateFormat;
    },
    // 格式化天数
    DateMinus(date1, date2) {
      var sdate = new Date(date1);
      var now = new Date(date2);
      var days = now.getTime() - sdate.getTime();
      var day = parseInt(days / (1000 * 60 * 60 * 24));
      return day;
    },
    // 日期时间补零
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    confirm: function() {
      if (this.password === this.$refs.passwords.value) {
        this.inputs = false;
        this.count_Down = true;
      } else {
        console.log("密码错误");
      }
      (this.passwords = ""), console.log(this.$refs.passwords.value);
      console.log(this.password);
    },
    clueImg(item) {
      if (item.order <= this.CLUE_STAGE) {
        return item.active;
      } else {
        return item.bg;
      }
    },
    stageImg() {
      if (this.CLUE_STAGE <= 2) {
        return require("../../assets/images/clue/stage3.png");
      } else {
        return require(`../../assets/images/clue/stage${this.CLUE_STAGE +
          1}.png`);
      }
    },
    mover(index) {
      this.hvoerIndex = index;
    },
    mleave() {
      this.hvoerIndex = -1;
    },
    jumpTo(url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        alert("Coming soon!");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.covering {
  width: 100%;
  height: 937px;
  background: url("../../assets/images/clue/PC_2.png") no-repeat;
  background-size: cover;
  background-position: center center;
  font-family: "jovanny";
  .count-Down {
    width: 1000px;
    height: 60px;
    line-height: 60px;
  }
  .inputs {
    width: 543px;
    height: 268px;
    background: #1b191a;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    .confirm {
      width: 245px;
      height: 47px;
      background: url("../../assets/images/clue/confirm.png") no-repeat;
      background-size: cover;
      position: absolute;
      top: 181px;
      left: 153px;
      img {
        width: 142px;
        position: relative;
        top: 53%;
        left: 50%;
        transform: translate(-53%, -50%);
        -webkit-transform: translate(-53%, -50%);
      }
    }
    input {
      border: 0px;
      height: 47px;
      width: 363.65px;
      position: absolute;
      left: 79px;
      background: #707070;
      top: 102px;
      outline: none;
      padding-left: 20px;
      font-size: 20px;
      color: #fff;
      letter-spacing: 10px;
    }
    .shut_s {
      position: absolute;
      right: 0;
      top: 0;
      background: #211f1f;
      width: 48px;
      height: 48px;
      img {
        margin-left: 6px;
      }
    }
    .please {
      width: 225px;
      position: absolute;
      left: 154px;
      top: 55px;
    }
  }
  .count-Down {
    position: relative;
    top: 50%;
    left: 62%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    img {
      width: 94%;
      position: absolute;
      left: -20%;
      top: -122%;
    }
    span {
      position: absolute;
      z-index: 20;
      color: #fff;
      top: 122px;
    }
    .dd {
      position: absolute;
      background: #fff;
      width: 12px;
      height: 12px;
      z-index: 200;
    }
    .dd_top {
      top: 22px;
    }
    .dd_button {
      top: 50px;
    }
    .dd_left {
      left: 33px;
    }
    .dd_center {
      left: 261px;
    }
    .dd_right {
      left: 488px;
    }
    .days_s {
      left: -120px;
    }

    .hrss {
      left: 118px;
    }
    .mins {
      left: 332px;
    }
    .secs {
      left: 562px;
    }

    .figure {
      position: absolute;
      top: -31px;
    }
    .day {
      left: -163px;
    }
    .days {
      left: -70px;
    }
    .hr {
      left: 63px;
    }
    .hrs {
      left: 155px;
    }
    .minute {
      left: 291px;
    }
    .minutes {
      left: 384px;
    }
    .second {
      left: 519px;
    }
    .seconds {
      left: 611px;
    }
  }
  video{
     mix-blend-mode: screen;
  }
  .shut {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 10px;
    right: 10px;
    background: url("../../assets/images/clue/2.png") no-repeat;
    background-size: cover;
  }

  .covering-enter-active,
  .covering-leave-active {
    transition: all 3s ease-in-out;
  }
  .covering-enter,
  .covering-leave-to {
    opacity: 0;
  }
}
</style>
